import { render, staticRenderFns } from "./AssessmentItem.vue?vue&type=template&id=0b9f8d22&scoped=true&"
import script from "./AssessmentItem.vue?vue&type=script&lang=js&"
export * from "./AssessmentItem.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentItem.vue?vue&type=style&index=0&id=0b9f8d22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9f8d22",
  null
  
)

export default component.exports